module.exports = __webpack_public_path__ + "img/pirate.53d625c3.svg";